import { SET_LISTS } from './types'

export const saveRabbitHoles = (lists) => {
  //   alert(`${uid}`)
  return {
    type: SET_LISTS,
    payload: lists,
  }
}
